(() => {
  if (customElements.get('nidol-fit-note')) return;
  customElements.define('nidol-fit-note', class extends HTMLElement {
    connectedCallback() {
      this.host = this.closest('product-info');
      if (!this.host || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.data.sectionId !== this.host.dataset.section) return;
        const source = event.data.html.querySelector('nidol-fit-note');
        if (!source || source.dataset.productId !== this.dataset.productId) return;
        const expanded = this.querySelector('details')?.open;
        this.innerHTML = source.innerHTML;
        if (expanded && this.querySelector('details')) this.querySelector('details').open = true;
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
})();
